import React from 'react'
import classes from 'components/Shared/Table/SortPriorityBadge/SortPriorityBadge.module.css'

function SortPriorityBadge ({ priority }) {
  return <div className={'my-auto px-1 ' + classes.badge}>
    {priority}
  </div>
}

export default SortPriorityBadge
